import { render, staticRenderFns } from "./NewslettersMessages.vue?vue&type=template&id=68ceaf2e&"
import script from "./NewslettersMessages.vue?vue&type=script&lang=ts&"
export * from "./NewslettersMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports